import React from 'react';
import Input from '../input';
import './index.scss';

export default class PhoneInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = { valid: true };
        this.onChange = this.onChange.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.value !== this.props.value || nextState.valid !== this.state.valid;
    }

    defaultValidate(number) {
        let isValidDigits = false;
        let isValidLength = false;

        if (number.length > 0 && number.match(/^[1-9]{1}[0-9]{0,8}$/)) {
            isValidDigits = true;
            if (number.length === (this.props.maxLength || 9)) {
                isValidLength = true;
            }
        } else if (number.length === 0) {
            isValidDigits = true;
            isValidLength = false;
        } else {
            isValidDigits = false;
            isValidLength = false;
        }

        return { isValidDigits, isValidLength };
    }

    onChange(e) {
        const validation = this.props.onValidate
            ? this.props.onValidate(e.target.value)
            : this.defaultValidate(e.target.value);

        if (validation) {
            this.props.onChange({
                isValidLength: validation.isValidLength,
                isValidDigits: validation.isValidDigits,
                number: e.target.value
            });
            this.setState({ valid: validation.isValidDigits && validation.isValidLength });
        }
    }

    render() {
        const className = this.props.className || '';

        return (
            <Input
                type="tel"
                value={this.props.value}
                className={`phone ${className}`}
                onChange={this.onChange}
                floating={this.props.floating || false}
                autoComplete="off"
                maxLength={this.props.maxLength || 9}
                inputMode="numeric"
                label={this.props.label}
                readonly={this.props.readonly || false}
                placeholder={this.props.placeholder}
                disabled={this.props.disabled || false}
                valid={this.state.valid}
            />
        );
    }
}
